import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { Button, Row, Col } from '@si-armes/dsfr-react';
import BoutonEtape from 'components/form/boutonsEtape/BoutonEtape';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_RETIRER_ARME_EN_ERREUR,
    CONTEXT_RETIRER_ARME_EN_ERREUR,
} from 'constants/apiUrls.constants';
import RoutesRatelier from '../../../../../ratelier/routes';
import { getPath } from '../../../../../../../utils/router';

const ErreurPossessionEtape3 = ({
    etapePrecedente,
    signalerArmeData,
    postApi,
    reinitialiseApi,
    armeRetirerRatelier,
}) => {
    const { handleSubmit } = useForm({
        mode: 'onChange',
    });
    const history = useHistory();

    useEffect(() => {
        if (armeRetirerRatelier !== null) {
            if (Array.isArray(Object.values(armeRetirerRatelier))) {
                reinitialiseApi(CONTEXT_RETIRER_ARME_EN_ERREUR);
                history.push(getPath(RoutesRatelier));
            }
        }
    }, [armeRetirerRatelier]);

    const onSubmit = async (dataForm) => {
        if (dataForm) {
            const justificatifFichier = [];
            if (signalerArmeData.justificatifFichier) {
                for (let i = 0; i < signalerArmeData.justificatifFichier.length; i += 1) {
                    // eslint-disable-next-line no-await-in-loop
                    justificatifFichier[i] = await signalerArmeData.justificatifFichier[
                        i
                    ].getFileToSend();
                }
            }

            postApi(
                usagerClientReducer,
                API_RETIRER_ARME_EN_ERREUR,
                {
                    ...signalerArmeData,
                    justificatifFichier,
                },
                CONTEXT_RETIRER_ARME_EN_ERREUR,
            );
        }
    };

    const choixErreurMotif = () => {
        switch (signalerArmeData.typeErreurMotif) {
            case 'jamais-detention':
                return "Je n'ai jamais détenu cette arme";
            case 'arme-doublon':
                return 'Cette arme est enregistrée en double dans mon râtelier';
            default:
                return `Je ne détiens plus cette arme "Motif : ${signalerArmeData.motifErreurSelectionLibelle}".`;
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
                <Col col={12}>
                    <strong>
                        L&apos;arme ci-dessus sera supprimée de votre râtelier numérique pour le
                        motif suivant : {choixErreurMotif()}
                    </strong>
                </Col>
            </Row>
            {signalerArmeData.justificatifFichier && signalerArmeData.justificatifFichier[0] && (
                <Row className="margin-top-xs" verticalAlign="bottom">
                    <Col col={3} lg={1}>
                        <strong>Justificatif : </strong>
                    </Col>
                    <Col col={9} lg={11}>
                        <Button
                            type="button"
                            onClick={() => {
                                signalerArmeData.justificatifFichier[0].download();
                            }}
                            name="downloadJustificatif"
                            variant="secondary"
                            icon="fr-fi-file-download-line"
                            iconPosition="right"
                        >
                            {signalerArmeData.justificatifFichier[0].filename}
                        </Button>
                    </Col>
                </Row>
            )}

            <BoutonEtape
                nameBtnSuivant="valider"
                labelBtnSuivant="Valider"
                labelBtnPrecedent="Revenir à l'étape précédente"
                actionPrecedente={etapePrecedente}
                btnSuivantDisabled={false}
            />
        </form>
    );
};

ErreurPossessionEtape3.propTypes = {
    etapePrecedente: PropTypes.string.isRequired,
    armeRetirerRatelier: PropTypes.string,
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    signalerArmeData: PropTypes.shape({
        uuidArme: PropTypes.string.isRequired,
        typeErreur: PropTypes.string.isRequired,
        typeErreurMotif: PropTypes.string.isRequired,
        motifErreurSelectionValue: PropTypes.string,
        motifErreurSelectionLibelle: PropTypes.string,
        justificatifFichier: PropTypes.array,
    }).isRequired,
};

export default connect(
    (state) => {
        const { isLoading, data } = state.armes.signalerErreur.retirerRatelier;
        return {
            isLoading,
            armeRetirerRatelier: data,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(ErreurPossessionEtape3);
